import { Link } from "react-router-dom";

export default function FooterSection() {
  return (
    <footer
      className="py-12 px-4 border-t border-white/5"
      style={{ background: "#0A0A0A" }}
      data-testid="footer-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Text Logo */}
          <a href="/" data-testid="footer-logo" className="flex items-center">
            <span
              className="text-xl font-black tracking-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              <span className="text-[#F0EDE8]">Vira</span>
              <span className="text-[#C9A84C]">Ai</span>
            </span>
          </a>

          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-testid="footer-nav">
            <Link
              to="/impressum"
              className="text-[#9A9A9A] hover:text-[#C9A84C] text-sm transition-colors duration-200"
              data-testid="footer-impressum-link"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              className="text-[#9A9A9A] hover:text-[#C9A84C] text-sm transition-colors duration-200"
              data-testid="footer-datenschutz-link"
            >
              Datenschutz
            </Link>
            <Link
              to="/agb"
              className="text-[#9A9A9A] hover:text-[#C9A84C] text-sm transition-colors duration-200"
              data-testid="footer-agb-link"
            >
              AGB
            </Link>
          </nav>

          {/* Copyright */}
          <p className="text-[#9A9A9A] text-xs">
            © {new Date().getFullYear()} Magic Design Agents UG · Bochum
          </p>
        </div>

        <div className="mt-6 pt-6 border-t border-white/5 text-center">
          <p className="text-[#9A9A9A] text-xs leading-relaxed max-w-2xl mx-auto">
            Anbieter: Magic Design Agents UG (haftungsbeschränkt) · Inhaber: Luca Berg · Bochum, Deutschland
            <br />
            Die dargestellten Ergebnisse sind Beispiele von echten Teilnehmern. Individuelle Ergebnisse können abweichen.
          </p>
        </div>
      </div>
    </footer>
  );
}
